import { ShortCode } from '@highereducation/wordpress';
import { CardContent, CardContentProps } from '@highereducation/hen-ui';

type CardContentShortcodeProps = {
  height?: CardContentProps['height'];
  align?: CardContentProps['align'];
  'align-md'?: CardContentProps['align'];
  'content-padding'?: CardContentProps['contentPadding'];
  children?: React.ReactNode;
};

/**
 * CardContentShortcode - Shortcode wrapper for the CardContent composite.
 *
 * Supported shortcode attributes:
 * - height: `auto` | `full`
 * - align / align-md: `left` | `center`
 * - content-padding: `default` (py-lg px-xl) | `none` — set `none` when the parent
 *   `[hen-ui-card]` already supplies the spacing via its own `padding` (avoids double padding).
 */
export const CardContentShortcode: ShortCode<CardContentShortcodeProps> = {
  balanced: true,
  component: ({
    height = 'auto',
    align,
    'align-md': alignMd,
    'content-padding': contentPadding,
    children,
  }) => {
    return (
      <CardContent
        height={height}
        align={align}
        align-md={alignMd}
        contentPadding={contentPadding}
      >
        {children}
      </CardContent>
    );
  },
};
